export const ROLE_CATEGORIES = {
  ADMIN: 'Admin',
  USER: 'User'
};
